export enum SubscriptionEvents {
  SubscriptionPurchased = 'Subscription\\SubscriptionPurchased',
  SubscriptionCancelled = 'Subscription\\SubscriptionCancelled',
  SubscriptionReactivated = 'Subscription\\SubscriptionReactivated',
  SubscriptionUpgraded = 'Subscription\\SubscriptionUpgraded',
}